import { api } from "./index";

export interface TechnicalEvaluation {
  id: string;
  tenderId: string;
  bidSubmissionId: string;
  evaluatorId?: string;
  status: 'PENDING' | 'IN_PROGRESS' | 'COMPLETED' | 'APPROVED' | 'REJECTED';
  evaluationDate?: string;
  evaluationNotes?: string;
  torComplianceScore?: number;
  documentComplianceScore?: number;
  overallScore?: number;
  isApproved?: boolean;
  rejectionReason?: string;
  createdAt: string;
  updatedAt: string;
  bidSubmission?: {
    id: string;
    companyName: string;
    totalPrice: number;
    submittedAt: string;
    documents?: Array<{
      id: string;
      fileName: string;
      documentType: string;
      uploadedAt: string;
    }>;
    bidItems?: Array<{
      id: string;
      quantity: number;
      unit: string;
      price: number;
      tenderItem?: {
        id: string;
        itemName: string;
        description?: string;
      };
    }>;
  };
  evaluator?: {
    id: string;
    fullName: string;
  };
  documentReviews?: Array<{
    id: string;
    documentRequirementId: string;
    documentType: string;
    documentName: string;
    isSubmitted: boolean;
    isCompliant?: boolean;
    reviewNotes?: string;
    score?: number;
    reviewedAt?: string;
    documentRequirement: {
      id: string;
      documentType: string;
      description?: string;
      isRequired: boolean;
      order: number;
    };
  }>;
  tender?: {
    id: string;
    description: string;
    torDocument?: {
      id: string;
      fileName: string;
    };
    requirements?: Array<{
      id: string;
      documentType: string;
      description?: string;
      isRequired: boolean;
      order: number;
    }>;
  };
}

export interface CreateTechnicalEvaluationDto {
  bidSubmissionId: string;
  evaluatorId?: string;
}

export interface UpdateTechnicalEvaluationDto {
  status?: 'PENDING' | 'IN_PROGRESS' | 'COMPLETED' | 'APPROVED' | 'REJECTED';
  evaluationNotes?: string;
  torComplianceScore?: number;
  documentComplianceScore?: number;
  isApproved?: boolean;
  rejectionReason?: string;
}

export interface UpdateDocumentReviewDto {
  isCompliant?: boolean;
  reviewNotes?: string;
  score?: number;
}

export const technicalEvaluationApi = {
  // Create technical evaluation for a specific bid submission
  createEvaluation: (tenderId: string, data: CreateTechnicalEvaluationDto) =>
    api.post<TechnicalEvaluation>(`/tenders/${tenderId}/technical-evaluations`, data),

  // Create technical evaluations for all bid submissions in a tender
  createBulkEvaluations: (tenderId: string) =>
    api.post<{ message: string; evaluations: TechnicalEvaluation[] }>(`/tenders/${tenderId}/technical-evaluations/bulk`),

  // List technical evaluations for a tender
  listEvaluations: (tenderId: string) =>
    api.get<TechnicalEvaluation[]>(`/tenders/${tenderId}/technical-evaluations`),

  // Get technical evaluation by ID
  getEvaluationById: (tenderId: string, evaluationId: string) =>
    api.get<TechnicalEvaluation>(`/tenders/${tenderId}/technical-evaluations/${evaluationId}`),

  // Update technical evaluation
  updateEvaluation: (tenderId: string, evaluationId: string, data: UpdateTechnicalEvaluationDto) =>
    api.put<TechnicalEvaluation>(`/tenders/${tenderId}/technical-evaluations/${evaluationId}`, data),

  // Update document review
  updateDocumentReview: (tenderId: string, evaluationId: string, reviewId: string, data: UpdateDocumentReviewDto) =>
    api.put<any>(`/tenders/${tenderId}/technical-evaluations/${evaluationId}/document-reviews/${reviewId}`, data),
};
